// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager","888":"course-setup"}[chunkId] || chunkId) + "-legacy." + {"132":"3e5bc5eb","303":"ccf9f492","354":"024f89c5","368":"d32d88ed","402":"cacff2b9","579":"07289c76","624":"bbd91ee5","738":"ce4f7dc4","838":"3787910e","888":"3e61de8b"}[chunkId] + ".js";
};